export interface SelectFieldOption {
  label: string
  value: string
  practitionerAction?: SpecialtyAction
  practitionerDocument?: DocumentType
  studentAction?: SpecialtyAction
  studentDocument?: DocumentType
}

export enum SpecialtyAction {
  License = 'LICENSE',
  LicenseAndUpload = 'LICENSE_AND_UPLOAD',
  Upload = 'UPLOAD',
  NotAvailable = 'NOT_AVAILABLE',
}

export enum DocumentType {
  Certificate = 'certificate',
  Degree = 'degree',
  DSS_Certificate = 'health coach certificate',
  Transcript = 'transcripts',
  BSN_Program_Transcript = 'BSN program transcript',
}
